import { post, get } from '@/http/request.js'

/**
 * 问题件处理列表
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchProblemPieceHandlingList = data => post('/vip/problem/page', data)

/**
 * 问题件处理导出
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
export const fetchProblemAsyExport = data => post('/vip/problem/problemAsyExport', data)

/**
 * 回复接口
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchProblemReply = data => post('/vip/problem/reply', data)

/**
 * 问题件通知状态
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchProblemNoticeStatus = params => get('/vip/problem/problemInform', params)

/**
 * 申请预约派送
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchProblemReplyByDelivery = data => post('/vip/problem/external/registration', data)

/**
 * 退回件是否可以批量申请
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchProblemBatchApplyCheckByReturn = params => get('/vip/rebackExpress/batchApplyCheck', params)

/**
 * 批量申请
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const fetchProblemBatchApplyByReturn = data => post('/vip/rebackExpress/batchApply', data)

/**
 * 预约派送退件运单号
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const batchCheckApply = data => post('/vip/rebackExpress/batchCheckApply', data)

/**
 * 获取预约派件可预约时间
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getAbnormalPiece = data => get('/vip/problem/getAbnormalPiece', data)
